export default __webpack_public_path__ + "static/media/TRUCK6.f02b6491.jpg";